import templateUrl from './risk-analysis.html';

export default {
  templateUrl,
  bindings: {
    adverseEvent: '<',
    injurySeverities: '<',
    injuryProbabilities: '<',
    occurrenceLikelihoods: '<',
    locked: '<'
  },
  controller: class RiskAnalysisComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    getRiskScore() {
      const risks = [
        this.adverseEvent.AnalysisQ1 || 0,
        this.adverseEvent.AnalysisQ2 || 0,
        this.adverseEvent.AnalysisQ3 || 0
      ];

      const sum = risks.reduce((a, b) => a + b, 0);
      return sum;
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/adverse-event/risk-analysis/risk-analysis.component.js